/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2484
 */

var r = require(/* 996 */"./2483/996")
module.exports = function (e) {
  return r(this.__data__, e) > -1
}
